import React, { useEffect, useState } from 'react';
import CreatePost from '../components/CreatePost';
import { useNavigate } from 'react-router-dom';
import i18n from '../i18n';

function CreatePostPage() {
    const navigate = useNavigate();
    const [key, setKey] = useState(0);

    const handlePostCreated = () => {
        navigate('/posts');
    };

    useEffect(() => {
        const handleLanguageChange = () => {
            setKey(prevKey => prevKey + 1);
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);

    return (
        <div className="create-post-page" key={key}>
            <CreatePost onPostCreated={handlePostCreated}/>
        </div>
    );
}

export default CreatePostPage;
